import { render, staticRenderFns } from "./CustomerPopover.vue?vue&type=template&id=5528d028&"
import script from "./CustomerPopover.vue?vue&type=script&lang=js&"
export * from "./CustomerPopover.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPopover.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerPopover.vue"
export default component.exports